import { createFileRoute } from "@tanstack/react-router";
import CreateListingV2 from "@/pages/CreateListingV2";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/vinde-masina/formular/")({
  head: () => routeHead("/de/vinde-masina/formular/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CreateListingV2 mode="private" />
  );
}
